import React from "react";
import "./addButtonTable.css";
import { useTranslation } from "react-i18next";

const AddButtonTable = ({
  buttonText,
  onClick,
  bgColor,
  textColor,
  borderColor,
}) => {
  const buttonStyle = {};
  const textStyle = {};
  const { t } = useTranslation();

  if (bgColor) {
    buttonStyle.backgroundColor = bgColor;
  }

  if (textColor) {
    textStyle.color = textColor;
  }

  if (borderColor) {
    buttonStyle.border = `1px solid ${borderColor}`; // 👈 add border color
  }

  return (
    <button type="button" onClick={onClick} className="button-with-image" style={buttonStyle}>
      {/* <div className="image-container"> */}
      {/* SVG Icon */}
      <svg
        className="plus-icon"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="7.5" cy="8.21436" r="7.5" fill="#DFA226" />
        <path
          d="M10.1284 8.64655H7.96415V10.8644H6.82843V8.64655H4.66415V7.61798H6.82843V5.40012H7.96415V7.61798H10.1284V8.64655Z"
          fill="white"
        />
      </svg>
      {/* </div> */}
      <span className="button-text ftw-4 common-text" style={textStyle}>
        {t(buttonText)
          ?.split(" ")
          .map(
            (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          )
          .join(" ")}
      </span>
    </button>
  );
};

export default AddButtonTable;
